module.exports = __webpack_public_path__ + "static/media/heartbeat-1.121f6001.png";